<div class="center" khA11ySearch [khA11yLabel]="'SEARCH_FIELD.SEARCH' | translate">
  <div class="d-flex">
    <kh-labeled-field [controlValue]="controlValue" [placeholder]="placeholder" class="min-search flex-grow-1"></kh-labeled-field>

    <button class="border-radius-sm search-button" (click)="search()" [khA11yLabel]="'SEARCH_FIELD.SEARCH' | translate ">
      <fa-icon khA11yHidden [icon]="['fas', 'search']" size="2x" class="white"></fa-icon>
    </button>
  </div>
</div>
